import { NgModule } from '@angular/core';
import { AdminLayoutModule } from './admin-layout.module';



@NgModule({
    imports: [
        AdminLayoutModule,
    ],
    exports: [
        AdminLayoutModule,
    ]
})
export class MainLayoutModule
{
}
